import React, {useState} from 'react'
import {useDispatch} from 'react-redux'
import {useLocation, useNavigate} from 'react-router-dom'
import {CHECK_MAIL_ROUTE} from '../../global-constants/routingConstants'
import {userForgotPassword} from '../../store/forgot-password/forgot-password.action'
import {AppDispatch} from '../../store/store'
import ForgotPasswordForm, {Payload} from '../components/ForgotPasswordForm'

function ForgotPasswordFormContainer() {
  const dispatch = useDispatch<AppDispatch>()
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState(null)
  const navigate = useNavigate()
  const location = useLocation()

  function handleSubmit(payload: Payload) {
    setSubmitting(true)
    setError(null)
    dispatch(userForgotPassword(payload))
      .then(() => {
        setSubmitting(false)
        navigate(CHECK_MAIL_ROUTE)
      })
      .catch(err => {
        setSubmitting(false)
        setError(err)
        console.error(err)
      })
  }

  return (
    <ForgotPasswordForm
      error={error}
      submitting={submitting}
      onSubmit={payload => handleSubmit(payload)}
      onClearError={() => setError(null)}
      locationState={location.state}
    />
  )
}

export default ForgotPasswordFormContainer
